import instance from '@apis/instance';
import {
  OrderAbleResponse,
  CreateFreeOrderResponse,
  CreateOrderRequest,
  CreateOrderResponse,
  OrderReceiptResponse, RecentOrdersResponse,
} from '@models/order';

class OrderApi {
  static createOrder(request: CreateOrderRequest): Promise<CreateOrderResponse> {
    return instance.post('/order/prepare', request);
  }

  static createFreeOrder(request: CreateOrderRequest): Promise<CreateFreeOrderResponse> {
    return instance.post('/order/free', request);
  }

  static getRecentOrders(): Promise<RecentOrdersResponse> {
    return instance.get('/orders/recent');
  }

  static getReceipt(orderId: string): Promise<OrderReceiptResponse> {
    return instance.get(`/order/${orderId}/receipt`);
  }

  static getOrderAble(orderNo: string): Promise<OrderAbleResponse> {
    return instance.get(`/order/${orderNo}/orderable`);
  }

  static cancelOrder(orderNo: string): Promise<never> {
    return instance.post(`/order/${orderNo}/cancel`);
  }
}

export default OrderApi;
